import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Components

import SecureInboxSummary from './subComponents/SecureInboxSummary';
import NonIndSideNav from '../navigation/NonIndSideNavigation';

// Constants

import { configs } from '@constants/configs/configs';
import { SAME_ROUTE_CLICK_EVENT } from '@constants/common/miscellaneous';


const SecureInbox = props => {

    const [emailShown, setEmailShown] = useState(null);
    const [query, setQuery] = useState('');

    const {
        environment: {
            links: {
                DASHBOARD
            },
        }
    } = props;

    const {
        routes
    } = configs;

    const isDelegationPage = props.location &&  props.location.pathname === routes.DELEGATION_CONSUMER;

    useEffect(() => {
        const handleSameRouteClick = (event) => {
            // Check if this is an inbox route click
            if (event.detail.route === routes.NEW_INBOX_HOME) {
                // Reset to message listing view
                setEmailShown(null);
            }
        };

        window.addEventListener(SAME_ROUTE_CLICK_EVENT, handleSameRouteClick);

        return () => {
            window.removeEventListener(SAME_ROUTE_CLICK_EVENT, handleSameRouteClick);
        };
    }, []);
    
    return (
        <main className="usa-layout-docs usa-section gi-main-section" id="individual-portal">
            <div className="grid-container gi-grid-container">
                <div className={`grid-row grid-gap gi-wrapper ${isDelegationPage && 'gi-wrapper-delegations'}`}>
                    <aside className="desktop:grid-col-3" id="side-nav">

                        <span className="grid-row back-to-dashboard">
                            <a className="gi-button gi-button__subtle-primary border-link" href={DASHBOARD}>
                                <FontAwesomeIcon icon="caret-left" size="1x" className="icon-link" />
                                <FormattedMessage id="dashboard.back.link" />
                            </a>
                        </span>

                        <NonIndSideNav {...{ setEmailShown, query, setQuery }} />

                    </aside>

                    <div className="desktop:grid-col-9" id="main-content">
                        <SecureInboxSummary {...{ emailShown, setEmailShown, query }} />
                    </div>
                </div>
            </div>
        </main>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment
});

export default connect(mapStateToProps)(SecureInbox);